import type { ConsentForm } from '../core/api/http-methods/generate-pay-url';

/** Fiuu's ConsentUrl must be POSTed with ConsentData (spec §4). Navigates the current tab. */
export function submitPostForm({ url, fields }: ConsentForm): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  form.style.display = 'none';
  for (const [name, value] of Object.entries(fields)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }
  document.body.appendChild(form);
  form.submit();
}
